// @ts-nocheck

import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Tab,
  TableCell,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@material-ui/core'
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Star } from '@material-ui/icons'
import Check from '@material-ui/icons/Check'
import { visuallyHidden } from '@mui/utils'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { ChevronDown, HelpCircle, Info, X } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { RULE_TYPES } from '../../../../../helpers/constants'
import { isNullOrEmpty, noop } from '../../../../../helpers/utils'
import CustomDialog from '../../../../common/CustomDialog'
import CustomTable from '../../../../table/CustomTable'
import useStyles from '../../allEnrollments/ProgramCourses.Style'
import AddOnprogramCareerInstructionForm from './AddOnProgramCareerInstructioForm'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <>{children}</>}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}
function AddOnProgramDetail({
  open,
  onClose,
  allHeadCells,
  attachedProgramDetail,
  readOnlyMode,
  pgmEnrolled,
  courseList,
  setCourseList,
  addOnProgramQuestions,
  setAddOnProgramQuestions,
  answerTextError,
  setAnswerTextError,
  programDetail,
  saveAddOnProgram,
  addOnProgramSaved,
  addOnProgramTabValue,
  handleAddOnProgramTabChange,
  addOnProgramQuestionsUgly,
  showCourseSelection,
  selectedGradeAddOnProgram,
  toggleGradeAddOnProgram,
}) {
  const classes = useStyles()
  const { t } = useTranslation()
  const dataParameter = 'id'
  const theme = useTheme()

  return (
    <CustomDialog
      paper="true"
      className="custom-dialog addon-program-popup"
      close={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle disableTypography id="customized-dialog-title" onClose={onClose}>
        <Typography variant="h5" tabIndex={0}>
          <Box pt={1} fontWeight={700}>
            {t('detailsAddOnProgram')}
          </Box>
        </Typography>
        <Typography variant="h5" tabIndex={0}>
          <Box pt={1} fontWeight={400}>
            {attachedProgramDetail?.pgm_name}
          </Box>
        </Typography>

        <IconButton aria-label="close" className="close-button" onClick={onClose} tabIndex={-1}>
          <X />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Tabs
          value={addOnProgramTabValue}
          onChange={handleAddOnProgramTabChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="tabs"
          variant="scrollable"
          className="custom-tabs"
        >
          <Tab label={t('courseDetails')} addOnProgramTabValue={0} id="userTab-0" tabIndex={0} />
          {!readOnlyMode && addOnProgramQuestions?.length && (
            <Tab
              label={t('applicationQuestions')}
              addOnProgramTabValue={1}
              id="userTab-1"
              tabIndex={0}
            />
          )}
        </Tabs>
        <TabPanel value={addOnProgramTabValue} index={0} dir={theme.direction}>
          {!readOnlyMode && !showCourseSelection && (
            <>
              <Grid item xs={12} sm={4} md={4}>
                <Box mt={1} mb={1}>
                  <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
                    <Box component="span" fontWeight="600">
                      {t('fields:currentGradeLevel')}
                    </Box>
                    <Box component="span" className="mandatory">
                      {t('fields:mandatory')}
                    </Box>
                  </Typography>
                  <TextField
                    className={classes.selectIcon + ' custom-input-field'}
                    name="q"
                    as={TextField}
                    variant="outlined"
                    fullWidth
                    size="small"
                    id="q"
                    autoComplete="q"
                    value={selectedGradeAddOnProgram}
                    onChange={(e) => toggleGradeAddOnProgram(e)}
                    placeholder={t('fields:searchByEmailName')}
                    select
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title={t('fields:currentGradeLevelHelp')} placement="top">
                            <HelpCircle className="help-icon" />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                    label={
                      <span style={visuallyHidden}>
                        {t('fields:currentGradeLevel')} ({t('fields:mandatory')}) (
                        {t('fields:currentGradeLevelHelp')}
                      </span>
                    }
                  >
                    {attachedProgramDetail?.pgm_grade_level?.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Grid>
              <Box display="flex" alignItems="center" mt={2}>
                <Box mr={1} color="var(--color-secondary-info)">
                  <Info width={16} height={16} />
                </Box>
                <Box
                  mb={0.5}
                  color="var(--color-secondary-info)"
                  fontStyle="italic"
                  fontSize="12px"
                  fontWeight={500}
                >
                  {t('availableCoursesInfo')}
                </Box>
              </Box>
            </>
          )}
          <Box width="100%" mt={2}>
            <>
              {(readOnlyMode ? attachedProgramDetail?.pgm_program_course_group : courseList)?.map(
                (groupRow, index) => {
                  const total =
                    groupRow.cg_rule_type === RULE_TYPES.NUMBER_OF_COURSES
                      ? parseFloat(groupRow.cg_rule_value)
                      : groupRow.cg_rule_type === RULE_TYPES.CREDIT_VALUE
                      ? parseFloat(groupRow.cg_rule_value)
                      : groupRow.cg_rule_type === RULE_TYPES.MAX_COURSE
                      ? parseFloat(groupRow.cg_rule_value)
                      : groupRow.cg_rule_type === RULE_TYPES.MAX_CREDIT
                      ? parseFloat(groupRow.cg_rule_value)
                      : groupRow.cg_rule_type === RULE_TYPES.MIN_MAX_COURSE
                      ? [parseFloat(groupRow.cg_rule_value), parseFloat(groupRow.cg_rule_value_2)]
                      : 0
                  const selected =
                    groupRow.cg_rule_type === RULE_TYPES.NUMBER_OF_COURSES ||
                    groupRow.cg_rule_type === RULE_TYPES.MIN_MAX_COURSE
                      ? groupRow.cg_course_group_item.filter(
                          (cg_course_group_item) => cg_course_group_item.isSelected
                        ).length
                      : groupRow.cg_rule_type === RULE_TYPES.CREDIT_VALUE
                      ? groupRow.cg_course_group_item
                          .filter((cg_course_group_item) => cg_course_group_item.isSelected)
                          .reduce((val, curr) => val + parseFloat(curr.cgi_credits) || 0, 0)
                      : groupRow.cg_rule_type === RULE_TYPES.MAX_COURSE
                      ? groupRow.cg_course_group_item.filter(
                          (cg_course_group_item) => cg_course_group_item.isSelected
                        ).length
                      : groupRow.cg_rule_type === RULE_TYPES.MAX_CREDIT
                      ? groupRow.cg_course_group_item
                          .filter((cg_course_group_item) => cg_course_group_item.isSelected)
                          .reduce((val, curr) => val + parseFloat(curr.cgi_credits) || 0, 0)
                      : 0
                  const isSelected =
                    groupRow.cg_rule_type !== RULE_TYPES.MIN_MAX_COURSE
                      ? total === selected
                      : selected >= total[0] && selected <= total[1]
                  const maxSelected =
                    groupRow.cg_rule_type !== RULE_TYPES.MIN_MAX_COURSE
                      ? total < selected
                      : total[1] < selected || total[0] > selected
                  return (
                    <Accordion
                      disablegutters="true"
                      key={groupRow.id}
                      elevation={0}
                      className={clsx(
                        classes.availableCourseList + ' program-list custom-accordion border-box',
                        {
                          selected: isSelected,
                        }
                      )}
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        aria-controls={`panel${index}_content`}
                        id={`panel${index}_header`}
                      >
                        <Box
                          width="100%"
                          p={1}
                          display="flex"
                          alignItems={{ xs: 'flex-start', sm: 'center' }}
                          justifyContent={{ xs: 'flex-start', sm: 'space-between' }}
                          flexDirection={{ xs: 'column', sm: 'row' }}
                        >
                          <Box display="flex" alignItems="center">
                            <Box mr={1}>
                              <ChevronDown className="text-primary" />
                            </Box>
                            <Typography
                              component="h4"
                              align="left"
                              variant="body2"
                              color="textPrimary"
                              tabIndex={0}
                            >
                              <Box component="span" fontWeight="600" fontSize="14px">
                                {groupRow.cg_course_group_name}
                              </Box>
                            </Typography>
                          </Box>
                          {!readOnlyMode ? (
                            isSelected ? (
                              <Box
                                mt={{ xs: 1, sm: 0 }}
                                component="div"
                                display="flex"
                                alignItems="center"
                                tabIndex={0}
                                className="text-success"
                              >
                                <Check width={16} height={16} />
                                <Box component="span" ml={1} fontWeight="500" fontSize="14px">
                                  {groupRow.cg_rule_type === RULE_TYPES.MAX_CREDIT
                                    ? t('selectedMaxCreditCourses')
                                    : t('selectedCourse', { count: selected })}
                                </Box>
                                <Box
                                  ml={1}
                                  borderRadius={30}
                                  px={1}
                                  py={0.5}
                                  className="course-count"
                                >
                                  {groupRow.cg_rule_type !== RULE_TYPES.MIN_MAX_COURSE
                                    ? `${selected}/${total}`
                                    : t('courseGroupMinMaxRuleInfoCount', {
                                        selected,
                                        min: total[0],
                                        max: total[1],
                                      })}
                                </Box>
                              </Box>
                            ) : maxSelected ? (
                              <Box
                                mt={{ xs: 1, sm: 0 }}
                                component="div"
                                display="flex"
                                alignItems="center"
                                tabIndex={0}
                                className={'text-secondary'}
                              >
                                <Info width={16} height={16} />
                                <Box component="span" ml={1} fontWeight="500" fontSize="14px">
                                  {t('error:errorCourseGroupSelectionExceeded')}
                                </Box>
                              </Box>
                            ) : (
                              <Box
                                mt={{ xs: 1, sm: 0 }}
                                component="div"
                                display="flex"
                                alignItems="center"
                                tabIndex={0}
                                className="text-info"
                              >
                                <Info width={16} height={16} />
                                <Box component="span" ml={1} fontWeight="500" fontSize="14px">
                                  {groupRow.cg_rule_type === RULE_TYPES.NUMBER_OF_COURSES &&
                                    t('courseGroupRuleNumber', {
                                      count: groupRow.cg_rule_value,
                                    })}
                                  {groupRow.cg_rule_type === RULE_TYPES.CREDIT_VALUE &&
                                    t('courseGroupRuleCredit', {
                                      count: groupRow.cg_rule_value,
                                    })}
                                  {groupRow.cg_rule_type === RULE_TYPES.MAX_COURSE &&
                                    t('courseGroupMaxCourse', {
                                      count: groupRow.cg_rule_value,
                                    })}
                                  {groupRow.cg_rule_type === RULE_TYPES.MAX_CREDIT &&
                                    t('courseGroupMaxCredit', {
                                      count: groupRow.cg_rule_value,
                                    })}
                                  {groupRow.cg_rule_type === RULE_TYPES.MIN_MAX_COURSE &&
                                    t('courseGroupMaxMinCount', {
                                      min: groupRow.cg_rule_value,
                                      max: groupRow.cg_rule_value_2,
                                    })}
                                </Box>
                                <Box
                                  ml={1}
                                  borderRadius={30}
                                  px={1}
                                  py={0.5}
                                  className="course-count"
                                >
                                  {groupRow.cg_rule_type !== RULE_TYPES.MIN_MAX_COURSE
                                    ? `${selected}/${total}`
                                    : t('courseGroupMinMaxRuleInfoCount', {
                                        selected,
                                        min: total[0],
                                        max: total[1],
                                      })}
                                </Box>
                              </Box>
                            )
                          ) : null}
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CustomTable
                          containerClass="course-group-table"
                          noDataMessage={t('noCourseListed')}
                          data={groupRow?.cg_course_group_item}
                          headCells={allHeadCells}
                          isSelection={
                            !readOnlyMode ? groupRow?.cg_course_group_item.length > 0 : false
                          }
                          showSelectAll={false}
                          dataParameter={dataParameter}
                          selected={groupRow?.cg_course_group_item
                            .filter((row) => row.isSelected)
                            .map((row) => row.id)}
                          setSelected={(event) => {
                            setCourseList((prevCourseList) =>
                              prevCourseList.map((cg) =>
                                cg.id === groupRow.id
                                  ? {
                                      ...cg,
                                      cg_course_group_item: cg.cg_course_group_item.map((cgi) => ({
                                        ...cgi,
                                        isSelected: !cgi.cgi_is_elective || event.includes(cgi.id),
                                      })),
                                    }
                                  : { ...cg }
                              )
                            )
                          }}
                        >
                          {groupRow?.cg_course_group_item
                            //.filter((row) => row.cgi_is_elective)
                            .map((row) => {
                              return (
                                <TableRow
                                  hover
                                  key={row.id}
                                  data-id={row.id}
                                  selected={row.isSelected ? true : false}
                                  className={
                                    !row.cgi_is_elective && row.isSelected ? 'core-selected' : null
                                  }
                                >
                                  {!readOnlyMode && (
                                    <TableCell padding="checkbox" width={0}>
                                      {!pgmEnrolled && row.cgi_is_elective && (
                                        <Checkbox
                                          name={row.id}
                                          // disabled={!row.cgi_is_elective || (!row.isSelected && isSelected)}
                                          checked={row.isSelected}
                                          onChange={(event) =>
                                            setCourseList((prevCourseList) =>
                                              prevCourseList.map((cg) =>
                                                cg.cg_id === groupRow.cg_id
                                                  ? {
                                                      ...cg,
                                                      cg_course_group_item:
                                                        cg.cg_course_group_item.map((cgi) =>
                                                          cgi.cgi_id === row.cgi_id
                                                            ? {
                                                                ...cgi,
                                                                isSelected: event.target.checked,
                                                              }
                                                            : { ...cgi }
                                                        ),
                                                    }
                                                  : { ...cg }
                                              )
                                            )
                                          }
                                          color="primary"
                                          disabled={programDetail?.pgm_enrolled}
                                        />
                                      )}
                                    </TableCell>
                                  )}

                                  <TableCell tabIndex={0}>
                                    <Box
                                      pl={
                                        !readOnlyMode && !pgmEnrolled && row.cgi_is_elective ? 4 : 0
                                      }
                                    >
                                      {row?.cgi_course?.cr_number}
                                    </Box>
                                  </TableCell>
                                  <TableCell tabIndex={0} className={classes.verticalSpaceRemove}>
                                    {!row.cgi_is_elective ? (
                                      <Box display="flex" alignItems="center" flexWrap="wrap">
                                        <Box mr={1} component="span">
                                          {row?.cgi_course?.cr_course_alias ||
                                            row?.cgi_course?.cr_name || (
                                              <Box
                                                ml={1}
                                                className="icon-color-light"
                                                component="span"
                                                fontSize="small"
                                              >
                                                {t('notAvailable')}
                                              </Box>
                                            )}
                                        </Box>
                                        <Box component="span" fontSize={13} className="label-muted">
                                          Core Course
                                        </Box>
                                      </Box>
                                    ) : (
                                      <>
                                        {row?.cgi_course?.cr_course_alias ||
                                          row?.cgi_course?.cr_name || (
                                            <Box
                                              ml={1}
                                              className="icon-color-light"
                                              component="span"
                                              fontSize="small"
                                            >
                                              {t('notAvailable')}
                                            </Box>
                                          )}
                                      </>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    tabIndex={0}
                                    className={
                                      classes.verticalSpaceRemove + ' vertical-space-remove'
                                    }
                                  >
                                    {row?.context_data?.publish_aggregated_ratings &&
                                    !isNullOrEmpty(row?.aggregateRating) &&
                                    row?.aggregateRating > 0 &&
                                    ((readOnlyMode &&
                                      row?.context_data?.cr_public_program_detail) ||
                                      (!readOnlyMode && row?.context_data?.program_detail)) ? (
                                      <Box
                                        color={'var(--color-star-orange)'}
                                        display={'flex'}
                                        alignItems={'center'}
                                        mt={2}
                                      >
                                        <Star width={24} height={24} />
                                        <Typography component="span" variant="body1">
                                          <Box
                                            fontSize={'16px'}
                                            color={'var(--color-grey-1)'}
                                            fontWeight={500}
                                          >
                                            {row?.aggregateRating}
                                          </Box>
                                        </Typography>
                                        <Typography component="span" variant="body1">
                                          <Box
                                            ml={1}
                                            fontSize={'14px'}
                                            color={'var(--color-grey-3)'}
                                            fontWeight={400}
                                          >
                                            ({row?.totalRatings} {t('rating')})
                                          </Box>
                                        </Typography>
                                      </Box>
                                    ) : (
                                      '-'
                                    )}
                                  </TableCell>
                                  <TableCell tabIndex={0}>
                                    {t('with$', { amount: row.cgi_amount })}
                                  </TableCell>
                                  <TableCell tabIndex={0}>{row.cgi_credits}</TableCell>
                                </TableRow>
                              )
                            })}
                        </CustomTable>
                      </AccordionDetails>
                    </Accordion>
                  )
                }
              )}
            </>
          </Box>
          <Box my={2} display={'flex'} justifyContent={'flex-end'}>
            {!readOnlyMode ? (
              addOnProgramQuestions?.length ? (
                <Button
                  className="custom-green-button text-transform-none"
                  size="large"
                  variant="contained"
                  disableElevation
                  color="primary"
                  onClick={(e) => handleAddOnProgramTabChange(e, 1)}
                >
                  {t('next')}
                </Button>
              ) : (
                <Button
                  className="custom-green-button text-transform-none"
                  size="large"
                  variant="contained"
                  disableElevation
                  color="primary"
                  onClick={() =>
                    saveAddOnProgram(programDetail?.pgm_attached_pgm?.ap_pgm_source_id)
                  }
                >
                  {t('add')}
                </Button>
              )
            ) : null}
          </Box>
        </TabPanel>
        <TabPanel value={addOnProgramTabValue} index={1} dir={theme.direction}>
          <AddOnprogramCareerInstructionForm
            addOnProgramQuestions={addOnProgramQuestions}
            setAddOnProgramQuestions={setAddOnProgramQuestions}
            answerTextError={answerTextError}
            setAnswerTextError={setAnswerTextError}
            programDetail={programDetail}
            addOnProgramSaved={addOnProgramSaved}
            saveAddOnProgram={saveAddOnProgram}
            addOnProgramQuestionsUgly={addOnProgramQuestionsUgly}
          />
        </TabPanel>
      </DialogContent>
    </CustomDialog>
  )
}

AddOnProgramDetail.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  allHeadCells: PropTypes.array,
  attachedProgramDetail: PropTypes.object,
  readOnlyMode: PropTypes.bool,
  pgmEnrolled: PropTypes.bool,
  selectedGradeAddOnProgram: PropTypes.string,
  courseList: PropTypes.array,
  setCourseList: PropTypes.func,
  showCourseSelection: PropTypes.bool,
  addOnProgramQuestions: PropTypes.array,
  setAddOnProgramQuestions: PropTypes.func,
  answerTextError: PropTypes.string,
  setAnswerTextError: PropTypes.func,
  addOnsList: PropTypes.array,
  programDetail: PropTypes.object,
  saveAddOnProgram: PropTypes.func,
  addOnProgramSaved: PropTypes.array,
  addOnProgramTabValue: PropTypes.number,
  handleAddOnProgramTabChange: PropTypes.func,
  addOnProgramQuestionsUgly: PropTypes.bool,
  showCourseSelection: PropTypes.bool,
  toggleGradeAddOnProgram: PropTypes.func,
}

AddOnProgramDetail.defaultProps = {
  open: false,
  onClose: noop,
  allHeadCells: [],
  attachedProgramDetail: {},
  readOnlyMode: false,
  pgmEnrolled: false,
  selectedGradeAddOnProgram: '',
  courseList: [],
  setCourseList: () => {},
  showCourseSelection: false,
  addOnProgramQuestions: [],
  setAddOnProgramQuestions: noop,
  answerTextError: '',
  setAnswerTextError: noop,
  addOnsList: [],
  programDetail: {},
  saveAddOnProgram: noop,
  addOnProgramSaved: [],
  addOnProgramTabValue: 0,
  handleAddOnProgramTabChange: noop,
  addOnProgramQuestionsUgly: false,
  showCourseSelection: false,
  toggleGradeAddOnProgram: noop,
}

export default AddOnProgramDetail
